'use client';

import { useSearchParams } from 'next/navigation';

export function useRedirectQueryParam() {
  const searchParams = useSearchParams();
  const redirect = searchParams.get('redirect') || '';

  const params = new URLSearchParams();

  if (redirect) {
    params.set('redirect', redirect);
  }

  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
}
